// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"6ba17b59","266":"ad51be73","288":"239bc196","316":"04db7593","381":"e4bf4554","617":"d619e5b7","631":"8fe8b66b","697":"24939e5f","787":"e3f7df33","934":"6f0bb4e7"}[chunkId] + ".chunk.js";
};